import api from "@/apis/system/IdentifyAPI";
import Crud from "./crud-base";
import httpClient from "@/apis/base/axios-httpclient";
var crud = new Crud("identify", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "UserId",
      code: "UserName",
      name: "FullName",
    },
  },
  datas: [],
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
  setDatas(state, data) {
    if (data.result) {
      if (data.result.length > 0) {
        state.datas.removeAll();
        state.datas = data.result;
      }
    }
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
